import { Dispatch, SetStateAction } from 'react';

import { ListTable, SortDirection } from '@atom/mui';
import { AssetRequestsFilters, Column } from '@atom/types/assetRequest';

import { getTableColumns } from '../customTenantUtilities';

const { TableHead, TableRow, TableCell } = ListTable;

type RequestsTableHeaderProps = {
  filters: AssetRequestsFilters;
  sortBy: string;
  setSortBy: Dispatch<SetStateAction<string>>;
  isAscending: boolean;
  setIsAscending: Dispatch<SetStateAction<boolean>>;
  isPortalView?: boolean;
};

const RequestsTableHeader = ({
  filters,
  sortBy,
  setSortBy,
  isAscending,
  setIsAscending,
  isPortalView = false,
}: RequestsTableHeaderProps) => {
  const columns = getTableColumns(filters.type, isPortalView);

  const getSortDirection = (field: string): SortDirection => {
    if (sortBy === field) {
      return isAscending ? 'asc' : 'desc';
    }

    return false;
  };

  const handleSortDirectionChange =
    (field: string) => (sortByValue: SortDirection) => {
      setSortBy(field);
      setIsAscending(sortByValue === 'asc');
    };

  const getHeaderCell = (column: Column) => {
    const columnProps = {
      key: column.label,
      'data-cy': `requestsTableHeaderCell-${column.label}`,
      ...(column.sortValue && {
        sortDirection: getSortDirection(column.sortValue),
        onSortChange: handleSortDirectionChange(column.sortValue),
      }),
    };

    return (
      <TableCell variant="head" {...columnProps}>
        {column.label}
      </TableCell>
    );
  };

  return (
    <TableHead>
      <TableRow header>{columns.map(column => getHeaderCell(column))}</TableRow>
    </TableHead>
  );
};

export default RequestsTableHeader;
